import ParticipantDTO from "@/dto/chat/ParticipantDTO";

export default class CreateChatRequest {
    public name: string | null = null;

    public email: string | null = null;

    public user: ParticipantDTO | null = null;
}
